import Vue from 'vue'
import { formatTitle, formatText, formatIndex } from '@/utils/common'
export default {
  data() {
    return {
      tabs: [
        { text: '会员', num: '待开', linkName: 'vipInvoice' },
        { text: 'UKEY', num: '待开', linkName: 'ukeyInvoice' },
        { text: '手续费', num: '待开', linkName: 'feeInvoice' }
      ],
      numQuery: {},
      nowTab: '',
      tabType: '',
      col: [],
      vipCol: [
        { field: 'infoNo', title: '序号', width: 50,
          formatter: (rowData, index) => {
            return formatIndex(index, this.pageIndex, this.pageSize)
          }
        },
        { field: 'operate', title: '操作', width: 80, componentName: 'vipInvoiceOpe' },
        { field: 'order_no', title: '订单编号', width: 230 },
        { field: 'order_time', title: '下单日期', width: 150 },
        { field: 'order_status', title: '状态', width: 80,
          formatter(rowData) {
            return formatText(rowData.order_status, ['待付款', '', '已付款'])
          }
        },
        { field: 'buy_type', title: '支付方式', width: 80,
          formatter(rowData) {
            return formatText(rowData.pay_type, ['', '线下转账', '支付宝'])
          }
        },
        { field: 'cust_no', title: '企业编码', width: 80 },
        { field: 'cust_name', title: '下单用户', width: 230, isResize: true, showTitle: true },
        { field: 'order_memo', title: '服务内容', width: 230, isResize: true },
        { field: 'order_money', title: '订单金额', width: 140 },
        { field: 'tax_name', title: '名称', width: 230, isResize: true, showTitle: true },
        { field: 'tax_address', title: '地址', width: 230, isResize: true, showTitle: true },
        { field: 'tax_tel', title: '电话', width: 140, showTitle: true },
        { field: 'tax_no', title: '税号', width: 140, showTitle: true },
        { field: 'tax_bank', title: '开户行', width: 230, isResize: true, showTitle: true },
        { field: 'tax_bank_no', title: '账号', width: 140, showTitle: true }
      ],
      ukeyCol: [
        { field: 'infoNo', title: '序号', width: 50,
          formatter: (rowData, index) => {
            return formatIndex(index, this.pageIndex, this.pageSize)
          }
        },
        { field: 'operate', title: '操作', width: 80, componentName: 'ukeyInvoiceOpe' },
        { field: 'order_id', title: '订单编号', width: 230 },
        { field: 'create_time', title: '下单日期', width: 150 },
        { field: 'buy_status', title: '状态', width: 80,
          formatter(rowData) {
            return formatText(rowData.buy_status, ['待付款', '已付款'])
          }
        },
        { field: 'buy_type', title: '支付方式', width: 80,
          formatter(rowData) {
            return formatText(rowData.buy_type, ['支付宝', '微信', '线下付款'])
          }
        },
        { field: 'cust_no', title: '企业编码', width: 80 },
        { field: 'cust_name', title: '下单用户', width: 230, isResize: true, showTitle: true },
        { field: 'order_content', title: '服务内容', width: 230, isResize: true },
        { field: 'order_money', title: '订单金额', width: 140 },
        { field: 'name', title: '名称', width: 230, isResize: true, showTitle: true },
        { field: 'address', title: '地址', width: 230, isResize: true, showTitle: true },
        { field: 'tel', title: '电话', width: 140, showTitle: true },
        { field: 'tax_number', title: '税号', width: 140, showTitle: true },
        { field: 'bank', title: '开户行', width: 230, isResize: true, showTitle: true },
        { field: 'account_number', title: '账号', width: 140, showTitle: true }
      ],
      feeCol: [
        { field: '', title: '序号', width: 50,
          formatter: (rowData, index) => {
            return formatIndex(index, this.pageIndex, this.pageSize)
          }
        },
        { field: 'operate', title: '操作', width: 80, componentName: 'feeInvoiceOpe' },
        { field: 'account_num', title: '财务流水单号', width: 140 },
        { field: 'statement_num', title: '业务流水单号', width: 120 },
        { field: 'sct_no', title: '合同编号', width: 100, showTitle: true },
        { field: 'payment_date', title: '付款日期', width: 150 },
        { field: 'payer', title: '付款方', width: 220, isResize: true },
        { field: 'receiver', title: '收款方', width: 220, isResize: true },
        { field: 'money', title: '服务费金额', width: 100 },
        { field: 'type', title: '类型', width: 80,
          formatter: function(rowData) {
            return formatText(rowData.type, ['', '收款', '付款', '解冻', '冻结', '服务费'])
          }
        },
        { field: 'status', title: '状态', width: 80, isResize: true,
          formatter() {
            return '成功'
          }
        }
      ],
      layout: []
    }
  },
  created() {
    this.initPage()
  },
  watch: {
    $route() {
      this.initFilterData()
      this.initPage()
    }
  },
  methods: {
    // 清空筛选条件
    initFilterData() {
      this.searchParams = {} // 切换tab，清空筛选条件
    },
    initPage() {
      this.pageIndex = 1
      this.pageSize = 30
      this.total = 0
      this.nowTab = this.$route.name
      if (this.nowTab === 'vipInvoice') {
        this.layout = ['code', 'name', 'date', 'export']
        this.col = this.vipCol
      } else if (this.nowTab === 'ukeyInvoice') {
        this.layout = ['code', 'name', 'date', 'export']
        this.col = this.ukeyCol
      } else {
        this.layout = ['payer', 'payee', 'date', 'export']
        this.col = this.feeCol
      }
      this.col.map(item => {
        item.titleAlign = 'left'
        item.columnAlign = 'left'
        if (item.showTitle !== undefined && item.showTitle) {
          item.formatter = (rowData, index, pageIndex, field) => {
            return formatTitle(rowData[field])
          }
        }
      })
      this.getData()
    }
  }
}

// 自定义列组件
Vue.component('vipInvoiceOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    makeout() {
      this.$router.push({
        name: 'makeout', params: { type: 'vip', id: this.rowData.order_no }
      })
    },
    detail(rowData) {
      this.$router.push({
        name: 'invoiceDetail', params: { type: 'vip', id: this.rowData.order_no }
      })
    }
  },
  render: function(h) {
    if (this.rowData.bill_info && this.rowData.bill_info === '0') {
      return h('span', {
        class: 'no-invoice'
      }, '____')
    }
    if (Number(this.rowData.tax_is_write) === 0) {
      // 开发票
      return h('div', {
        class: 'link-btn',
        on: {
          click: this.makeout
        }
      }, '开发票')
    } else {
      // 查看发票
      return h('div', {
        class: 'link-btn',
        on: {
          click: this.detail
        }
      }, '查看')
    }
  }
})

// 自定义列组件
Vue.component('ukeyInvoiceOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    makeout() {
      this.$router.push({
        name: 'makeout', params: { type: 'ukey', id: this.rowData.id }
      })
    },
    detail(rowData) {
      this.$router.push({
        name: 'invoiceDetail', params: { type: 'ukey', id: this.rowData.id }
      })
    }
  },
  render: function(h) {
    if (this.rowData.bill_info && this.rowData.bill_info === '0') {
      return h('span', {
        class: 'no-invoice'
      }, '____')
    }
    if (this.rowData.has_bill === '0') {
      // 开发票
      return h('div', {
        class: 'link-btn',
        on: {
          click: this.makeout
        }
      }, '开发票')
    } else {
      // 查看发票
      return h('div', {
        class: 'link-btn',
        on: {
          click: this.detail
        }
      }, '查看')
    }
  }
})

// 自定义列组件
Vue.component('feeInvoiceOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    makeout() {
      this.$router.push({
        name: 'makeout', params: { type: 'fee', id: this.rowData.id }
      })
    },
    detail() {
      this.$router.push({
        name: 'invoiceDetail', params: { type: 'fee', id: this.rowData.id }
      })
    }
  },
  render: function(h) {
    if (this.rowData.has_bill === '0') {
      // 开发票
      return h('div', {
        class: 'link-btn',
        on: {
          click: this.makeout
        }
      }, '开发票')
    } else {
      // 查看发票
      return h('div', {
        class: 'link-btn',
        on: {
          click: this.detail
        }
      }, '查看')
    }
  }
})
